module.exports = __webpack_public_path__ + "static/media/icon-next-dark.5ead4f5e.svg";